import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import usePrivate from '@afosto/auth-react/usePrivate';
import AppsList from './AppsList';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const AppStore = () => {
  usePrivate();

  const intl = useIntl();
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['app:integrations:read']);

  if (!hasPermissions()) {
    return (
      <Page title={intl.formatMessage(translations.title)} fullWidth>
        <UnauthorizedComponent />
      </Page>
    );
  }

  return (
    <Page title={intl.formatMessage(translations.title)} fullWidth>
      <AppsList />
    </Page>
  );
};

export default AppStore;
